var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSamparkKkBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCA3A",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M18.068 4.62l.015.008C19.277 5.318 20 6.533 20 7.881v6.272a3.685 3.685 0 0 1-1.932 3.228l-5.677 3.141a3.987 3.987 0 0 1-3.792-.005l-5.657-3.131A3.65 3.65 0 0 1 1 14.153V7.847c0-1.336.745-2.588 1.932-3.228L8.61 1.478a3.987 3.987 0 0 1 3.792.005l5.667 3.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.97 14.97l-2.47-1.234-2.475 1.205a.284.284 0 0 1-.404-.306l.463-2.535-1.963-1.784a.284.284 0 0 1 .153-.492l2.736-.366 1.238-2.317a.284.284 0 0 1 .502.002l1.24 2.353 2.736.365a.284.284 0 0 1 .153.492l-1.963 1.784.461 2.528a.284.284 0 0 1-.406.305z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSamparkKkBadge);
export default __webpack_public_path__ + "static/media/icon_sampark_kk_badge.3fbffecf9a292caa8a284468a5d02861.svg";
export { ForwardRef as ReactComponent };